<template>
  <CreateDashboardModal
    source="create_dashboard_modal"
    :visible="isVisible"
    :space="selectedSpace"
    @update:visible="handleVisibilityUpdate"
  />
</template>

<script setup>
import { ref, onMounted, onUnmounted } from "vue";
import { toFetchComponents } from "@/src/utils/dashboardUtils.js";
import eventBus from "@/src/utils/eventBus.js";
import CreateDashboardModal from "@/src/components/dashboard_components/modals/CreateDashboardModal.vue";

const isVisible = ref(false);
const selectedSpace = ref(null);

const handleOpenModal = (data) => {
  try {
    selectedSpace.value = data?.space || null;
    isVisible.value = true;
  } catch (error) {
    console.error("An error occurred while opening modal: ", error);
  }
};

const handleVisibilityUpdate = (value) => {
  try {
    isVisible.value = value;
    if (!value) {
      selectedSpace.value = null;
    }
  } catch (error) {
    console.error("An error occurred while updating visibility: ", error);
  }
};

onMounted(() => {
  toFetchComponents();
  eventBus.on("open-create-dashboard-modal", handleOpenModal);
});

onUnmounted(() => {
  eventBus.off("open-create-dashboard-modal", handleOpenModal);
});
</script>
